module.exports =  {
    showWarnings: true,
    showMessages: true,
}
